import React, { useState, useEffect, useRef } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { fetchDefault, fetchPostDefault } from './Utils.js';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    backAbsolute: {
        position: 'fixed',
        bottom: theme.spacing(5),
        right: theme.spacing(5),
    },
}));

export default function SignIn() {;
    const classes = useStyles();
    let history = useHistory();

    const [loginId, setLoginId] = React.useState('');
    const [password, setPassword] = React.useState('');

    const [errorOpen, setErrorOpen] = React.useState(false);
    

    const loginMember = (event) => {

        event.preventDefault();

        //로그인
        fetchPostDefault('/User/Login',
            {
                LoginId: loginId,
                Password: password
            },
            (data) => {
                window.location.assign('/');
            },
            (error) => {
                setErrorOpen(true);
            }
        );        
    };

    useEffect(() => {
        const pageTimeout = setTimeout(() => {
            history.push('/display/connected');
        }, 240000);

        return () => {
            clearTimeout(pageTimeout);
        }
    }, []);

    return (
        <Container component="main" maxWidth="xs">



            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    로그인
                </Typography>
                <form onSubmit={loginMember} className={classes.form} noValidate>
                    <TextField
                        onChange={(event) => setLoginId(event.target.value)}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="loginId"
                        label="아이디"
                        name="loginId"
                    />
                    <TextField
                        onChange={(event) => setPassword(event.target.value)}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="비밀번호"
                        type="password"
                        id="password"
                    />
                    <Button
                        onClick={loginMember}
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        로그인
                    </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link href="/findIdPw" variant="body2">
                                아이디/비밀번호 찾기
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link href="/signUp" variant="body2">
                                {"회원가입 →"}
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={8}>
                
            </Box>


            <Dialog
                open={errorOpen}

                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary">
                        아이디 또는 비밀번호를 확인하세요.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary">
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={errorOpen}
                onClose={()=>setErrorOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary" style={{ marginTop: 20 }}>
                        아이디 또는 비밀번호를 확인하세요.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setErrorOpen(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}


// WEBPACK FOOTER //
// ./src/components/SignIn.js